module.exports = __webpack_public_path__ + "img/perivolischoolstrust-logo.c047f82f.png";